<app-card
  title="Medical History"
  headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title numbered-header"
  contentClasses="p-4 card-body-background"
  data-qa-id="Order Medical History"
>
  @if (hasCustomQuestions) {
    @for (question of customMedicalHistoryQuestions; track question.id) {
      <app-dynamic-form-question [question]="question" [form]="medicalHistoryForm"></app-dynamic-form-question>
    }
  } @else {
    <app-yes-no-details-field
      yesNoLabel="Are you currently on any medication?"
      yesNoControlName="onMedication"
      detailsControlName="medicationDetails"
      [form]="medicalHistoryForm"
    ></app-yes-no-details-field>
    <app-yes-no-details-field
      yesNoLabel="Do you have any allergies that you are aware of?"
      yesNoControlName="hasAllergies"
      detailsControlName="allergiesDetails"
      [form]="medicalHistoryForm"
    ></app-yes-no-details-field>
    <app-yes-no-details-field
      yesNoLabel="Do you have any other conditions?"
      yesNoControlName="hasOtherConditions"
      detailsControlName="otherConditionsDetails"
      [form]="medicalHistoryForm"
    ></app-yes-no-details-field>
  }
  @if (!storageService.isShipped) {
    <app-order-upsell-checkbox [test]="priorityProcessingUpsell">
      <div>
        Standard physician review time is typically 1-2 hours. Add priority processing and your prescription request
        will be placed at the top of the physician review queue, most priority orders are sent to the pharmacy within
        20-30 minutes.
      </div>
    </app-order-upsell-checkbox>
  }
</app-card>
